export default __webpack_public_path__ + "static/media/news3.e99006a8.png";